import React, { useEffect, useState } from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import { removeAuthToken, decodedToken } from '../utils/auth';
import { ChevronRight, User, LoaderCircle } from 'lucide-react';
import { statisticsfilterdata } from "../services/apiService";
import Swal from 'sweetalert2';

const DashboardScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const email = localStorage.getItem("email");
  const decode = decodedToken();
  const [state, setState] = useState({
    uploadedImage: null,
    analysis: null
  });

  const handleStatisticsClick = async () => {
      try {
        setLoading(true);
        const data = await statisticsfilterdata();
        console.log("statisticsfilterdata API Response:", data);
        updateState({ analysis: data });
        navigate("/statistics-analysis");
      } catch (error) {
        console.error("Error in statisticsfilterdata click:", error.message);
      } finally {
        setLoading(false);
      }
    };

  const updateState = (newState) => {
    setState(prev => ({
      ...prev,
      ...newState
    }));
  };
  
  useEffect(() => {
  const relabelingProducts = location.state?.relabelingProducts || [];

  if (relabelingProducts.length > 0) {
  Swal.fire({
  icon: 'info',
  title: 'Relabeling Products',
  text: 'You have product records available for relabeling',
  confirmButtonText: 'OK',
  confirmButtonColor: '#3085d6',
  width: '450px', 
  customClass: {
    popup: 'p-2 text-sm', 
    title: 'text-base font-semibold',
    confirmButton: 'px-3 py-1 text-sm'
  }
});
} 
  const isWeakPassword = sessionStorage.getItem("isWeakPassword") === "true";

  if (isWeakPassword) {
    Swal.fire({
      icon: "warning",
      title: "Weak Password!",
      text: "Use at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character (!@#$%^&*). Please update your password.",
      confirmButtonText: "OK",
      confirmButtonColor: "#ff9800",
    }).then(() => {
      sessionStorage.removeItem("isWeakPassword");
    });
  }
}, [location.state]);

  const hasManagementAccess = () => {
    const userPermissions = decode?.permissions || {};
    return userPermissions.Management || 
           userPermissions.templateManagement || 
           userPermissions.photoManagement;
  };

  const menuItems = [
    {
      title: 'AI Optical Detection System (AI-ODS)',
      description: 'Light Leakage, Mura, Spot, line, band issues detection and labeling.',
      path: '/AI-ODS' ,
      permission: 'AiOpticalDetectionSystemAiOds',
    },
    {
      title: 'AI Audio Detection System (AI-ADS)',
      description: 'Visualizes and analyzes audio buzz issues.',
      path: '/audio-calibaration',
      permission: 'AudioIssueVisualization',
    },
    {
      title: 'Statistics and Analysis',
      description: 'Views analysis and charts.',
      path: '/statistics-analysis',
      permission: 'StatisticsAndAnalysis',
      onClick: handleStatisticsClick,
    },
    {
      title: 'HW Change Verification Assessment',
      description: 'Verification assessment of potential issues caused by hardware modifications.',
      path: '/hardware-change',
      permission: 'HWChangeVerificationAssessment',
    },
    {
      title: 'SW Change Verification Assessment',
      description: 'Verification assessment of potential issues caused by software modifications.',
      path: '/sw-change',
      permission: 'SWChangeVerificationAssessment',
    },
    {
    title: 'Project Reporting Hub',
    description: 'Certification, HW and SW PR status visualization and reporting.',
    path: '/project-reporting',
    permission: 'ProjectReportingHub',
  },
  {
    title: 'Certification',
    description: 'Tracking project progress',
    path: '/Certification',
    permission: 'Certification',
  },
  {
    title: 'Vendor Capability',
    description: 'Hardware, Software, and Certification verification capability query.',
    path: '/vendor-capability',
    permission: 'VendorCapability',
  },
    {
      title: 'Management',
      description: 'Manage user accounts, templates, and issue-related photos in a centralized interface.',
      path: '/management',
      permission: 'Management',
      isManagement: true,
    },
  ];

  const hasPermission = (item) => {
    if (item.isManagement) {
      return hasManagementAccess();
    }
    const userPermissions = decode?.permissions || {};
    return userPermissions[item.permission] === true;
  };

  const handleProfile = () => {
    navigate(`/profile/${email}`);
  };

  const handleMenuClick = async (item, subItem) => {
    console.group("Navigation Process");
    
    if (!hasPermission(item)) {
      console.warn(" User doesn't have permission for:", item.permission);
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: `You don't have permission to access ${item.title}`,
        confirmButtonText: "OK",
        confirmButtonColor: "#ff4444",
      });
      console.groupEnd();
      return;
    }

    if (item.title === "Statistics and Analysis") {
      try {    
        setLoading(true);
        const filters = {};
        let data = state.analysis;
        
        if (!data) {
          data = await statisticsfilterdata(filters);
          updateState({ analysis: data }); 
        }

        navigate(item.path, {
          state: {
            analysis: data, 
          },
        });
        console.groupEnd();
        return;
      } catch (error) {
        console.error(" Error fetching statistics:", error);
        Swal.fire({
          icon: "error",
          title: "Failed to fetch data",
          text: error.message || "Something went wrong fetching statistics",
          confirmButtonText: "OK",
          confirmButtonColor: "#ff4444",
        });
        console.groupEnd();
        return;
        } finally {
        setLoading(false);
      
      }
    }
    if (subItem?.path) {
      navigate(subItem.path);
    } else if (item.path) {
      navigate(item.path);
    }
    console.groupEnd();
  };

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="flex items-center p-4 border-b border-gray-800 justify-center sm:justify-start">
        <h1 className="p-2 text-xl font-medium">Dashboard</h1>
      </div>
      <div className="px-4 w-full pb-20">
        {menuItems.filter(item => hasPermission(item)).map((item, index) => {
          const isWebOnly =
            item.title === 'AI Audio Detection System (AI-ADS)' ||
            item.title === 'Statistics and Analysis' ||
            item.title === 'SW Change Verification Assessment' ||
            item.title === 'Vendor Capability' ||
            item.title === 'Certification' ||
            item.title === 'Project Reporting Hub' ||
            item.title === 'HW Change Verification Assessment';

          return isWebOnly ? (
            <div key={index} className="hidden md:block">
              <button
                onClick={() => handleMenuClick(item)}
                className="p-2 w-full flex items-center justify-between py-4 border-b border-gray-800 group min-h-[72px] hover:bg-gray-800 cursor-pointer"
              >
                <div className="flex flex-col items-start max-w-full truncate">
                  <span className="font-medium text-white truncate text-base md:text-lg lg:text-md">
                    {item.title}
                  </span>
                  <span className="text-sm text-gray-400 line-clamp-2">{item.description}</span>
                </div>
                <ChevronRight
                  className="w-5 h-5 text-gray-400 group-hover:text-white ml-2"
                />
              </button>
            </div>
          ) : (
            <div key={index} className="w-full">
              <button
                onClick={() => handleMenuClick(item)}
                className="p-2 w-full flex items-center justify-between py-4 border-b border-gray-800 group min-h-[72px] hover:bg-gray-800 cursor-pointer"
              >
                <div className="flex flex-col items-start max-w-full text-left">
                  <span className="font-medium text-white text-sm md:text-lg whitespace-normal break-words">
                    {item.title}
                  </span>
                  <span className="text-xs md:text-sm text-gray-400 whitespace-normal break-words pl-0 -ml-0">
                    {item.description}
                  </span>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-white ml-2" />
              </button>
            </div>
          );
        })}
      </div>
      <div className="fixed bottom-0 left-0 right-0 bg-gray-900 py-3 px-4 border-t border-gray-800">
        <div className="flex justify-end">
          <button className="flex flex-col items-center text-gray-400" onClick={handleProfile}>
            <User className="w-6 h-6 mb-1" />
            <span className="text-xs">My Account</span>
          </button>
        </div>
      </div>
      {loading && (
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 z-50">
          <div className="bg-gray-800 w-70 h-70 flex flex-col items-center justify-center rounded-xl shadow-lg p-6">
            <LoaderCircle className="w-12 h-12 text-white animate-spin mb-4" />
            <p className="text-white text-base whitespace-nowrap">Loading Statistics And Analysis...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardScreen;